module.exports = __webpack_public_path__ + "static/img/ebook_index_three.30274e81.jpg";